import type { NuxtApp } from 'nuxt/app';

export const getHrTime = (): bigint => (import.meta.server ? process.hrtime.bigint() : 0n);

export function recordSsrPhase(nuxtApp: NuxtApp, label: string, start: bigint) {
	if (!import.meta.server) return;

	const event = nuxtApp.ssrContext?.event;
	if (!event) return;

	if (!event.context.ssrPhases) {
		event.context.ssrPhases = {};
	}

	event.context.ssrPhases[label] = Number(getHrTime() - start) / 1e6;
}
